var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScatter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 100,
    viewBox: "0 0 121 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.377451,
    y: 0.377451,
    width: 120.245,
    height: 99.2451,
    rx: 3.62255,
    fill: "white",
    stroke: "#EFEFEF",
    strokeWidth: 0.754902
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.82031,
    y: 22.8242,
    width: 105,
    height: 54.4687,
    stroke: "#ECECEC",
    strokeWidth: 0.328124
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.65625 40.707H113.984",
    stroke: "#ECECEC",
    strokeWidth: 0.328124
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.65625 31.8477H113.984",
    stroke: "#ECECEC",
    strokeWidth: 0.328124
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.65625 49.5664H113.984",
    stroke: "#ECECEC",
    strokeWidth: 0.328124
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.65625 58.4258H113.984",
    stroke: "#ECECEC",
    strokeWidth: 0.328124
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.65625 67.2852H113.984",
    stroke: "#ECECEC",
    strokeWidth: 0.328124
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.375 22.6602L26.375 77.4569",
    stroke: "#ECECEC",
    strokeWidth: 0.328124
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7656 22.6602L43.7656 77.4569",
    stroke: "#ECECEC",
    strokeWidth: 0.328124
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1562 22.6602L61.1562 77.4569",
    stroke: "#ECECEC",
    strokeWidth: 0.328124
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5469 22.6602L78.5469 77.4569",
    stroke: "#ECECEC",
    strokeWidth: 0.328124
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9375 22.6602L95.9375 77.4569",
    stroke: "#ECECEC",
    strokeWidth: 0.328124
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.1484,
    cy: 65.1484,
    r: 0.984373,
    fill: "#496DFF",
    fillOpacity: 0.5,
    stroke: "#496DFF",
    strokeWidth: 0.328124
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.1484,
    cy: 70.1484,
    r: 0.984373,
    fill: "#496DFF",
    fillOpacity: 0.5,
    stroke: "#496DFF",
    strokeWidth: 0.328124
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.1484,
    cy: 63.1484,
    r: 0.984373,
    fill: "#496DFF",
    fillOpacity: 0.5,
    stroke: "#496DFF",
    strokeWidth: 0.328124
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.1484,
    cy: 48.1484,
    r: 0.984373,
    fill: "#496DFF",
    fillOpacity: 0.5,
    stroke: "#496DFF",
    strokeWidth: 0.328124
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.5703,
    cy: 38.2461,
    r: 0.984373,
    fill: "#496DFF",
    fillOpacity: 0.5,
    stroke: "#496DFF",
    strokeWidth: 0.328124
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.148,
    cy: 33.1484,
    r: 0.984373,
    fill: "#496DFF",
    fillOpacity: 0.5,
    stroke: "#496DFF",
    strokeWidth: 0.328124
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.977,
    cy: 28.4023,
    r: 0.984373,
    fill: "#496DFF",
    fillOpacity: 0.5,
    stroke: "#496DFF",
    strokeWidth: 0.328124
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.1484,
    cy: 68.1484,
    r: 0.984373,
    fill: "#496DFF",
    fillOpacity: 0.5,
    stroke: "#496DFF",
    strokeWidth: 0.328124
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.1484,
    cy: 46.1484,
    r: 0.984373,
    fill: "#496DFF",
    fillOpacity: 0.5,
    stroke: "#496DFF",
    strokeWidth: 0.328124
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.5703,
    cy: 32.0117,
    r: 0.984373,
    fill: "#496DFF",
    fillOpacity: 0.5,
    stroke: "#496DFF",
    strokeWidth: 0.328124
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.1484,
    cy: 72.1484,
    r: 0.984373,
    fill: "#496DFF",
    fillOpacity: 0.5,
    stroke: "#496DFF",
    strokeWidth: 0.328124
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.1484,
    cy: 62.1484,
    r: 0.984373,
    fill: "#496DFF",
    fillOpacity: 0.5,
    stroke: "#496DFF",
    strokeWidth: 0.328124
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.1484,
    cy: 62.1484,
    r: 0.984373,
    fill: "#496DFF",
    fillOpacity: 0.5,
    stroke: "#496DFF",
    strokeWidth: 0.328124
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.1484,
    cy: 61.1484,
    r: 0.984373,
    transform: "rotate(90 34.1484 61.1484)",
    fill: "#7335CB",
    fillOpacity: 0.5,
    stroke: "#7335CB",
    strokeWidth: 0.328124
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.1484,
    cy: 55.1484,
    r: 0.984373,
    transform: "rotate(90 47.1484 55.1484)",
    fill: "#7335CB",
    fillOpacity: 0.5,
    stroke: "#7335CB",
    strokeWidth: 0.328124
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.1484,
    cy: 65.1484,
    r: 0.984373,
    transform: "rotate(90 24.1484 65.1484)",
    fill: "#7335CB",
    fillOpacity: 0.5,
    stroke: "#7335CB",
    strokeWidth: 0.328124
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.1484,
    cy: 67.1484,
    r: 0.984373,
    transform: "rotate(90 28.1484 67.1484)",
    fill: "#7335CB",
    fillOpacity: 0.5,
    stroke: "#7335CB",
    strokeWidth: 0.328124
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.1484,
    cy: 67.1484,
    r: 0.984373,
    transform: "rotate(90 22.1484 67.1484)",
    fill: "#7335CB",
    fillOpacity: 0.5,
    stroke: "#7335CB",
    strokeWidth: 0.328124
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.3919,
    cy: 39.3917,
    r: 0.984373,
    transform: "rotate(13.9706 74.3919 39.3917)",
    fill: "#7335CB",
    fillOpacity: 0.5,
    stroke: "#7335CB",
    strokeWidth: 0.328124
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 82.3919,
    cy: 36.3917,
    r: 0.984373,
    transform: "rotate(13.9706 82.3919 36.3917)",
    fill: "#7335CB",
    fillOpacity: 0.5,
    stroke: "#7335CB",
    strokeWidth: 0.328124
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    r: 0.984373,
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 24.1484 70.1484)",
    fill: "#8CD6A0",
    fillOpacity: 0.5,
    stroke: "#8CD6A0",
    strokeWidth: 0.328124
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    r: 0.984373,
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 17.6797 69.1133)",
    fill: "#8CD6A0",
    fillOpacity: 0.5,
    stroke: "#8CD6A0",
    strokeWidth: 0.328124
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    r: 0.984373,
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 28.1484 64.1484)",
    fill: "#8CD6A0",
    fillOpacity: 0.5,
    stroke: "#8CD6A0",
    strokeWidth: 0.328124
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    r: 0.984373,
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 26.1484 62.1484)",
    fill: "#8CD6A0",
    fillOpacity: 0.5,
    stroke: "#8CD6A0",
    strokeWidth: 0.328124
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    r: 0.984373,
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 13.7422 73.707)",
    fill: "#8CD6A0",
    fillOpacity: 0.5,
    stroke: "#8CD6A0",
    strokeWidth: 0.328124
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    r: 0.984373,
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 39.1484 60.1484)",
    fill: "#8CD6A0",
    fillOpacity: 0.5,
    stroke: "#8CD6A0",
    strokeWidth: 0.328124
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    r: 0.984373,
    transform: "matrix(0.97042 -0.241425 -0.241425 -0.97042 61.3919 53.3934)",
    fill: "#8CD6A0",
    fillOpacity: 0.5,
    stroke: "#8CD6A0",
    strokeWidth: 0.328124
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    r: 0.984373,
    transform: "matrix(0.97042 -0.241425 -0.241425 -0.97042 79.5032 47.4403)",
    fill: "#8CD6A0",
    fillOpacity: 0.5,
    stroke: "#8CD6A0",
    strokeWidth: 0.328124
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    r: 0.984373,
    transform: "matrix(0.97042 -0.241425 -0.241425 -0.97042 75.4583 35.2567)",
    fill: "#8CD6A0",
    fillOpacity: 0.5,
    stroke: "#8CD6A0",
    strokeWidth: 0.328124
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    r: 0.984373,
    transform: "matrix(0.97042 -0.241425 -0.241425 -0.97042 98.6946 36.2411)",
    fill: "#8CD6A0",
    fillOpacity: 0.5,
    stroke: "#8CD6A0",
    strokeWidth: 0.328124
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScatter);
export default __webpack_public_path__ + "static/media/scatter.bd5cec3886cacfb642e99ad645879100.svg";
export { ForwardRef as ReactComponent };